import { RJSFSchema } from '@rjsf/utils';

export const TEMPLATE_BODY_HTML_FIELD = 'template_body_html';

export type HtmlBodyFieldMode = 'default' | 'inline' | 'external';

const hasHtmlBodyField = (schema?: RJSFSchema): boolean => {
  const properties = (schema as { properties?: Record<string, unknown> })?.properties;
  return !!properties?.[TEMPLATE_BODY_HTML_FIELD];
};

export function enhanceFlowStepUiSchema(
  uiSchema: Record<string, unknown>,
  htmlBodyFieldMode: HtmlBodyFieldMode = 'default',
  schema?: RJSFSchema
): Record<string, unknown> {
  if (htmlBodyFieldMode === 'default' || !hasHtmlBodyField(schema)) {
    return uiSchema;
  }

  const fieldUi = uiSchema[TEMPLATE_BODY_HTML_FIELD] as Record<string, unknown> | undefined;

  if (htmlBodyFieldMode === 'external') {
    return {
      ...uiSchema,
      [TEMPLATE_BODY_HTML_FIELD]: {
        ...fieldUi,
        'ui:widget': 'hidden',
      },
    };
  }

  return {
    ...uiSchema,
    [TEMPLATE_BODY_HTML_FIELD]: {
      ...fieldUi,
      'ui:widget': 'TipTapEditor',
    },
  };
}
